
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/mentions",
      function () {
        return require("private-next-pages/analytics/mentions.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/mentions"])
      });
    }
  